<template>
  <div>
    <v-row class="ma-0">
      <v-col cols="0" md="2"></v-col>
      <v-col cols="12" md="8" class="align-center">
        <v-card class="ma-2" elevation="0">
          <div
            :style="
              $vuetify.breakpoint.smAndUp
                ? 'padding-block: 50px; padding-inline: 155px'
                : 'padding-block: 10px; padding-inline: 30px'
            "
          >
            <div class="d-flex justify-space-between">
              <v-btn
                depressed
                class="
                  no-background-hover
                  font-weight-thin
                  textLight--text
                  pa-0
                "
                style="background-color: transparent; text-transform: unset"
                @click="
                  () => {
                    e1 = e1 === 2 ? 1 : 1;
                  }
                "
              >
                <v-icon left>mdi-chevron-left </v-icon
                >{{ $t("user.detailSignUp.back") }}</v-btn
              >
              <div>
                <span class="text--secondary text-caption"
                  >{{ $t("user.detailSignUp.step") }} {{ e1 }}
                  {{ $t("user.detailSignUp.of") }} 2</span
                ><br />
                <!-- <router-link
                  class="text-subtitle-2 font-weight-bold"
                  style="text-decoration: none"
                  :to="{ name: 'SignUp' }"
                >
                  {{ $t("user.signUp.signUp") }}
                </router-link> -->
                <v-btn
                  depressed
                  class="
                    no-background-hover
                    font-weight-thin
                    textLight--text
                    pa-0
                  "
                  style="
                    background-color: transparent;
                    text-transform: unset;
                    height: auto;
                  "
                  @click="addSkip"
                >
                  {{ $t("user.detailSignUp.skipForNow") }}</v-btn
                >
              </div>
            </div>
            <div class="pt-13" :key="reRender">
              <h3 class="font-weight-medium textLight--text text-start pb-3">
                {{ $t("user.detailSignUp.completeProfile") }}
              </h3>
              <component-1
                v-if="e1 === 1"
                @completed="completed"
                :values="component1Data"
              />
              <component-2
                v-if="e1 === 2"
                @completed2="save"
                :values="component2Data"
              />
            </div>
            <!-- <div class="mb-10 mt-5 text-caption font-weight-thin">
              {{ $t("user.signIn.alreadyHaveAccount") }}
              <span>
                <router-link
                  style="text-decoration: none"
                  :to="{ name: 'SignIn' }"
                >
                  {{ $t("user.signIn.login") }}
                </router-link>
              </span>
              {{ $t("user.here") }}
            </div> -->
          </div>
        </v-card>
      </v-col>
      <v-col cols="0" md="2"></v-col>
    </v-row>
  </div>
</template>
<script>
import { saveToLocalStorage } from "../../core-module/util/localStorageHandler";
import Component1 from "../components/SignUpDetails1.vue";
import Component2 from "../components/SignUpDetails2.vue";
import { updateEmployee } from "../methods/updateEmployee";

export default {
  data() {
    return {
      component1Data: {},
      component2Data: {},
      e1: 1,
      userProfile: {},
      reRender: 1,
    };
  },
  components: {
    Component1,
    Component2,
  },
  apollo: {
    getProfile() {
      return {
        query: require("@/app/user-module/api/query/getProfile.gql"),
        result({ data, loading }) {
          if (data && data.getProfile) {
            this.userProfile = data.getProfile;
            this.resetFormData();
          }

          this.loading = loading;
        },
      };
    },
  },
  methods: {
    resetFormData() {
      const roleKey = this.userProfile?.role?.toLowerCase();
      this.component1Data.firstName = this.userProfile.firstName
        ? this.userProfile.firstName
        : "";
      this.component1Data.lastName = this.userProfile.lastName
        ? this.userProfile.lastName
        : "";
      this.component1Data.gender =
        this.userProfile[roleKey] && this.userProfile[roleKey].gender
          ? this.userProfile[roleKey].gender
          : "MALE";
      this.component1Data.dob =
        this.userProfile[roleKey] && this.userProfile[roleKey].dob
          ? this.$moment(parseInt(this.userProfile[roleKey].dob)).format(
              "DD/MM/YYYY"
            )
          : "";
      this.component1Data.email = this.userProfile.email
        ? this.userProfile.email
        : "";
      this.component1Data.phone =
        this.userProfile.phone && this.userProfile.phone.number
          ? this.userProfile.phone.number
          : "";
      this.component2Data.image = this.userProfile.avatar
        ? this.userProfile.avatar
        : "";
      this.component2Data.designation =
        this.userProfile[roleKey] && this.userProfile[roleKey].designation
          ? this.userProfile[roleKey].designation
          : "";
      // this.component2Data.organization =
      //   this.userProfile[roleKey] && this.userProfile[roleKey].organization
      //     ? this.userProfile[roleKey].organization._id
      //     : "";
      this.reRender++;
    },
    completed(data) {
      this.component1Data = data;
      this.e1 = 2;
    },
    addSkip() {
      saveToLocalStorage("Skipped", { value: true, date: new Date() });
      this.$router.push({ name: "Home" });
    },
    save(data) {
      let saveData = {
        designation: data.designation ? data.designation : null,
        gender: this.component1Data.gender ? this.component1Data.gender : null,
        dob: this.component1Data.dob ? this.component1Data.dob : null,
        user: {
          firstName: this.component1Data.firstName
            ? this.component1Data.firstName
            : "",
          lastName: this.component1Data.lastName
            ? this.component1Data.lastName
            : "",
          email: this.component1Data.email ? this.component1Data.email : "",
          phone: {
            countryCode: "+965",
            number: this.component1Data.phone ? this.component1Data.phone : "",
          },
        },
      };
      if (
        this.component2Data.image &&
        this.component2Data.image instanceof Blob
      ) {
        saveData.user.avatar = this.component2Data.image;
      }
      // if (this.userProfile.role === "EMPLOYEE") {
      //   saveData.organization = data.organization ? data.organization : null;
      // }

      this.update(saveData);
    },
    update(data) {
      updateEmployee({
        id: this.userProfile?.employee?._id,
        input: data,
      }).then(response => {
        if (response.data) {
          this.$router.push({ name: "Home" });
        }
        // if (response.error) {
        //   this.errorFromApi = this.$t("somethingWentWrong");
        // }
        // this.loading = false;
      });
    },
  },
};
</script>
